import React from "react";
import { useNavigate } from "react-router-dom";
import {
  getStoredUser,
  getCurrentUser,
  getUserRole,
} from "../services/authService";
import {
  CurrencyDollarIcon,
  ArrowRightOnRectangleIcon,
  UserCircleIcon,
} from "@heroicons/react/24/outline";
import logo from "../assests/images/logo.png";

const SimpleHeader = () => {
  const navigate = useNavigate();

  // Get current user info
  const currentUser = getStoredUser() || getCurrentUser();
  const username = currentUser?.username || "Admin User";

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/login");
  };

  return (
    <header className="bg-white shadow-lg border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo and Brand */}
          <div className="flex items-center">
            <div className="flex items-center space-x-3">
              <div className="flex-shrink-0">
                <img
                  src={logo}
                  alt="Investors Portal Logo"
                  className="w-20 rounded-lg object-cover"
                  style={{ backgroundColor: "white", padding: "2px" }}
                />
              </div>
              <div>
                <h1 className="text-xl font-bold text-gray-900">
                  Investors Portal
                </h1>
                <p className="text-sm text-gray-500">
                  Database Management System
                </p>
              </div>
            </div>
          </div>

          {/* User Menu */}
          <div className="flex items-center space-x-4">
            <div className="hidden sm:flex items-center space-x-3">
              <UserCircleIcon className="h-8 w-8 text-gray-400" />
              <div className="text-sm">
                <p className="font-medium text-gray-900">
                  {getUserRole() === "admin"
                    ? "Admin User"
                    : getUserRole() === "admin_team"
                    ? "Team User"
                    : "User"}
                </p>
                <p className="text-gray-500">{username}</p>
              </div>
            </div>

            <button
              onClick={handleLogout}
              className="flex items-center px-3 py-2 rounded-md text-sm font-medium text-red-600 hover:text-red-700 hover:bg-red-50 transition-colors duration-200"
            >
              <ArrowRightOnRectangleIcon className="h-4 w-4 mr-2" />
              <span className="hidden sm:inline">Logout</span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default SimpleHeader;
